import _ from 'lodash';

import {
  RESERVATION_LOADING,
  RESERVATION_CREATED,
  RESERVATION_ERROR,
  CANCEL_BOOKING,
  CANCEL_BOOKING_ERROR,
  RESCHEDULE_BOOKING,
  RESCHEDULE_BOOKING_ERROR,
  SET_RESCHEDULE_OBJECT,
  CLEAR_RESCHEDULE_OBJECT,
  CLEAR_RESERVATION_ERROR,
  CLEAR_RESCHEDULE_ERROR,
  CLEAR_CANCELLATION_ERROR,
} from '../actions/reservationActions';

const INITIAL_STATE = {
  rescheduleObject: null,
};

export default function reservationsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESERVATION_LOADING:
      return {
        ...state,
        status: 'loading',
        error: null,
      };

    case RESERVATION_ERROR:
      return {
        ...state,
        error: {
          status: action.payload.status,
          statusText: action.payload.statusText,
          message: action.payload.data.message,
          trialCreditsRemaining: action.payload.data.trialCreditsRemaining,
        },
        status: 'error',
      };

    case RESERVATION_CREATED:
      const newState = _.omit(state, 'error');

      return {
        ...newState,
        status: 'success',
      };

    case CANCEL_BOOKING:
      return { rescheduleObject: null };

    case CANCEL_BOOKING_ERROR:
      return {
        ...state,
        error: {
          bookingId: action.id,
          status: action.payload.status,
          statusText: action.payload.statusText,
          message: action.payload.data.message,
        },
        status: 'cancellation_error',
      };

    case RESCHEDULE_BOOKING:
      return { rescheduleObject: null };

    case RESCHEDULE_BOOKING_ERROR:
      return {
        ...state,
        error: {
          bookingId: action.id,
          status: action.payload.status,
          statusText: action.payload.statusText,
          message: action.payload.data.message,
        },
        status: 'reschedule_error',
      };

    case SET_RESCHEDULE_OBJECT:
      return { ...state, rescheduleObject: action.payload };

    case CLEAR_RESCHEDULE_OBJECT:
      return { ...state, rescheduleObject: null };

    case CLEAR_RESERVATION_ERROR:
      if (state.status === 'error') {
        return _.omit(state, 'error', 'status');
      }
      return state;

    case CLEAR_RESCHEDULE_ERROR:
      if (state.status === 'reschedule_error') {
        return _.omit(state, 'error', 'status');
      }
      return state;

    case CLEAR_CANCELLATION_ERROR:
      if (state.status === 'cancellation_error') {
        return _.omit(state, 'error', 'status');
      }
      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reservationsReducer.js